var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      staticClass: "modal-info",
      attrs: {
        show: _vm.show,
        title: _vm.modalTitle,
        saveButton: { visible: false },
        cancelButton: { title: "Fechar" },
        size: "medium",
        needHeader: false,
        relativeBackdrop: true,
        contentCentered: _vm.contentCentered,
      },
      on: { close: _vm.closeModal },
    },
    [
      _c("div", {
        class: _vm.classContent,
        domProps: { innerHTML: _vm._s(_vm.infoHtml) },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }